/**
 * ERP ids (e.g. the ERP contractor id on a service provider client assignment) are stored in PEAK
 * in signed INT(10) columns, and PEAK's service provider import rejects anything else with a 400
 * (PEAK-51568). MYS-7387: validate in the UI and sanitize before exporting to PEAK.
 */
export const ERP_ID_MAX_VALUE = 2147483647

/** Empty values are valid (field is optional); otherwise 1-10 digits within the INT range. */
export function isValidErpId(value: unknown): boolean {
	return normalizeErpId(value) !== null
}

/**
 * Returns '' for an empty value, the trimmed digits for a valid value, and null for an invalid value.
 */
export function normalizeErpId(value: unknown): string | null {
	if (value === null || value === undefined) return ''
	if (typeof value !== 'string' && typeof value !== 'number') return null

	const trimmed = String(value).trim()
	if (trimmed === '') return ''
	if (!/^\d{1,10}$/.test(trimmed)) return null
	if (Number(trimmed) > ERP_ID_MAX_VALUE) return null

	return trimmed
}
